import script from "./FavouritesList.vue?vue&type=script&setup=true&lang=js"
export * from "./FavouritesList.vue?vue&type=script&setup=true&lang=js"

import "./FavouritesList.vue?vue&type=style&index=0&id=a6e18ed2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e18ed2"]])

export default __exports__